import {
	Button,
	FormHelperText,
	Grid,
	Link,
	Paper,
	Typography,
	styled,
} from '@mui/material';
import { InputText } from 'primereact/inputtext';
import React, { useState } from 'react';
import routes from '../../constants/Routes';
import img from '../../images/bgImg.jpg';
import userAvatar from '../../images/user-avatar.png';
import { forgotPassword } from 'services/userProfile.services';
import { validateSchema } from 'validations/common';
import { forgotPasswordSchema } from 'validations/forgotPassword.validation';
import { useNavigate } from 'react-router';
import { useAppDispatch } from 'Stores/Hooks/hooks';
import { SET_PROGRESS } from 'Stores/Slices/progressSlice';
import { SEND_MESSAGE } from 'Stores/Slices/errorHandlingSlice';
import theme from 'theme';

const PREFIX = 'ForgotPasswordNew';

const classes = {
	container: `${PREFIX}-container`,
	paperBox: `${PREFIX}-paperBox`,
	columnGrid: `${PREFIX}-columnGrid`,
	loginBoxChild: `${PREFIX}-loginBoxChild`,
	avatarIcon: `${PREFIX}-avatarIcon`,
	formField: `${PREFIX}-formField`,
	inputFields: `${PREFIX}-inputFields`,
	labelField: `${PREFIX}-labelField`,
	label: `${PREFIX}-label`,
	loginButtonGrid: `${PREFIX}-loginButtonGrid`,
	loginButton: `${PREFIX}-loginButton`,
	forgotPwdLabel: `${PREFIX}-forgotPwdLabel`,
};

const Root = styled(Grid)(() => ({
	[`& .${classes.container}`]: {
		height: '100vh',
		backgroundImage: `url(${img})`,
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		[theme.breakpoints.down('md')]: {
			justifyContent: 'center',
			alignItems: 'center',
		},
	},

	[`& .${classes.paperBox}`]: {
		marginRight: '10vw',
		borderRadius: theme.spacing(2),
		width: '400px',
		height: '450px',
		backgroundColor: 'rgb(255, 255, 255, 0.4)',
		[theme.breakpoints.down('md')]: {
			marginRight: '0px',
		},
	},

	[`& .${classes.columnGrid}`]: {
		padding: theme.spacing(4),
	},

	[`& .${classes.loginBoxChild}`]: {
		paddingTop: theme.spacing(4),
	},
	[`& .${classes.avatarIcon}`]: {
		width: '54px',
		height: '57px',
		fontSize: '250',
		marginBottom: theme.spacing(2),
	},
	[`& .${classes.formField}`]: {
		paddingLeft: theme.spacing(4),
		paddingRight: theme.spacing(4),
	},
	[`& .${classes.inputFields}`]: {
		borderRadius: theme.spacing(1),
		border: 'none',
		width: '100%',
		height: '50px',
		marginTop: theme.spacing(1),
	},
	[`& .${classes.labelField}`]: {
		paddingLeft: theme.spacing(4),
		paddingRight: theme.spacing(4),
	},
	[`& .${classes.label}`]: {
		color: '#ffffff',
		fontSize: '13px',
	},
	[`& .${classes.loginButtonGrid}`]: {
		padding: theme.spacing(4),
		paddingTop: theme.spacing(1),
	},
	[`& .${classes.loginButton}`]: {
		minWidth: '100%',
		borderRadius: '10px',
	},
	[`& .${classes.forgotPwdLabel}`]: {
		fontWeight: 600,
		color: '#ffffff',
	},
}));

function ForgotPasswordNew() {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [errorObj, setErrorObj] = useState<any>({});
	const [username, setUsername] = useState('');
	const [loginError, setLoginError] = useState('');
	const dispatch = useAppDispatch();
	const handleEmail = (e: any) => {
		setEmail(e.target.value);
		setLoginError('');
	};

	const handleUsername = (e: any) => {
		setUsername(e.target.value);
	};

	const gotoLogin = () => {
		navigate(routes.LOGIN.path);
	};
	const forgotPwdHandler = async (e: any) => {
		setLoginError('');
		dispatch(SET_PROGRESS(true));
		const userCredentils = { username: username, emailId: email };
		validateSchema(forgotPasswordSchema, userCredentils)
			.then(async () => {
				e.preventDefault();
				if (email.trim() && username.trim() !== '') {
					try {
						const resp: any = await forgotPassword(userCredentils);
						if (resp.data.statusCode === 200) {
							dispatch(SET_PROGRESS(false));
							dispatch(
								SEND_MESSAGE({
									message: 'Mail Sent Successfully',
									type: 'success',
								}),
							);
							setTimeout(() => {
								navigate(routes.LOGIN.path);
							}, 3000);
						}
					} catch (error: any) {
						dispatch(SET_PROGRESS(false));
						if (
							error.response &&
							error.response.errors &&
							error.response.errors[0]
						)
							dispatch(
								SEND_MESSAGE({
									message: error.response.errors[0],
									type: 'error',
								}),
							);
						if (error.response)
							dispatch(
								SEND_MESSAGE({ message: error.response, type: 'error' }),
							);
						if (error)
							dispatch(SEND_MESSAGE({ message: error, type: 'error' }));
					}
				}
			})
			.catch((error: any) => {
				setErrorObj(error);
				dispatch(SET_PROGRESS(false));
			});
	};

	return (
		<Root>
			<Grid
				container
				direction="column"
				justifyContent="center"
				alignItems="flex-end"
				className={classes.container}>
				<Grid item>
					<Paper elevation={2} className={classes.paperBox}>
						<Grid
							container
							className={classes.columnGrid}
							direction="column"
							justifyContent="flex-end">
							<Grid
								item
								container
								xs={12}
								className={classes.loginBoxChild}
								justifyContent="center">
								<Grid item>
									<img
										className={classes.avatarIcon}
										src={userAvatar}
									/>
								</Grid>
							</Grid>
							<Grid item xs={12} className={classes.formField}>
								<Typography className={classes.forgotPwdLabel}>
									FORGOT PASSWORD?
								</Typography>
							</Grid>
							<Grid item xs={12} className={classes.formField}>
								<InputText
									required
									autoFocus
									id="username"
									className={classes.inputFields}
									value={username}
									placeholder="Username"
									onChange={handleUsername}
								/>
								<FormHelperText error={true}>
									{errorObj.username}
								</FormHelperText>
							</Grid>
							<Grid item xs={12} className={classes.formField}>
								<InputText
									required
									className={classes.inputFields}
									value={email}
									id="email"
									placeholder="Email ID"
									onChange={handleEmail}
								/>
								<FormHelperText error={true}>
									{errorObj.emailId}
								</FormHelperText>
							</Grid>

							<Grid item container xs={12} direction="row">
								<Grid item xs={12} className={classes.loginButtonGrid}>
									<Button
										type="submit"
										variant="contained"
										color="primary"
										onClick={forgotPwdHandler}
										className={classes.loginButton}>
										{' '}
										SEND EMAIL{' '}
									</Button>
								</Grid>
							</Grid>
							<Grid item container xs={12} className={classes.formField}>
								<Grid item xs={12} style={{ paddingLeft: '60px' }}>
									<Link
										align="right"
										onClick={gotoLogin}
										className={classes.forgotPwdLabel}
										style={{ color: '#fff' }}>
										Or Back to Login?
									</Link>
								</Grid>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
		</Root>
	);
}

export default ForgotPasswordNew;
